export default __webpack_public_path__ + "51ecc252d64fecb875d21dfb1c976e4c.png";